import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "../../annotations";
import * as Bedrock from ".";

const CATEGORIES_SERVICE = `${Constants.API_URL}/bedrock/categories`;

export type GetCategoriesParams = {
  type: Bedrock.CategoryType;
  excludeUnusedCategories?: boolean;
  globalOnly?: boolean;
  page?: number;
  perPage?: number;
  sort?: "created_date" | "updated_date" | "name";
  order?: "asc" | "desc";
};

export class CategoryServices {
  @scCatchServiceException()
  static async getCategories(params: GetCategoriesParams): Promise<Bedrock.Page<Bedrock.Category>> {
    const { data } = await axios.get<Bedrock.Page<Bedrock.Category>>(CATEGORIES_SERVICE, { params });
    return data;
  }
}
